import { getCookie, setCookie } from '../hooks/useCookie';
import getVarsFromUrl from './getVarsFromUrl';

type IUtmCampaign = {
    value: string;
    time: number;
};

class UtmCampaign {
    public setFromUrl(url: string): void {
        const { utm_campaign } = getVarsFromUrl<{ utm_campaign: string }>(url);
        if (utm_campaign) {
            const existingUtm_campaign = getCookie<IUtmCampaign>('utm_campaign');
            setCookie<IUtmCampaign>('utm_campaign', { value: utm_campaign, time: Date.now() }, {
              days: 7,
              path: '/',
            });
        }
    }


    public get(): string {
        const affiliate = getCookie<IUtmCampaign>('utm_campaign');
        return affiliate?.value;
    }
}

export default new UtmCampaign();
